'use strict';

/**
 * Collection for sets
 *
 * @category   Collection
 * @module     collection
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var Collection = require('base/Colido.Collection');
var SetModel = require('../models/set');

var SetsCollection = Collection.extend({
    api: function() {
        var api = '/sets';

        if (this.catalog) {
            api =  this.catalog.api + '/' + this.catalog.id + '/sets';
        }

        return api;
    },

    getName: function() {
        var name = 'collection:sets';

        if (this.catalog) {
            name =  this.catalog.collection.name + ':' + this.catalog.id + ':sets';
        }

        return name;
    },

    name: 'collection:sets',

    model: SetModel,

    sortDefault: 'lastEdited.desc',

    sortFieldsMap: {
        'itemCount.asc': 'itemCount.asc-name.asc',
        'itemCount.desc': 'itemCount.desc-name.asc',
        'lastEdited': 'modifiedTime',
    },

    initialize: function(models, options) {
        options = options || {};

        if (!options.catalog) {
            return Colido.config.debug && console.log('You have to provide a catalog model as option when initializing a sets collection');
        }

        this.catalog = options.catalog;

        this.name = this.getName();

        this.listenTo(App.radio('collection').vent, 'object:destroy', this.removeObjectsFromSets.bind(this));

        this.listenTo(App.radio(this.name).vent, 'updated', function(data) {
            this.setFromWebsocket(data, {remove: false});
        }.bind(this));

        this.listenTo(App.radio(this.name).vent, 'removed', function(data) {
            this.remove(data); //data [1,2,3]
        }.bind(this));

        this.listenTo(App.radio(this.name).vent, 'added', function(data) {
            this.add(data);
        }.bind(this));
    },

    /**
     * Removes the object from all sets, that contains the object
     * @param {CollectionModule.ObjectModel[]} objects The related objects
     */
    removeObjectsFromSets: function(objects) {
        objects = _.isArray(objects) ? objects : [objects];

        this.each(function(setModel) {
            var items = _.clone(setModel.get('items'));
            var itemCount = setModel.get('itemCount');

            _.each(objects, function(object) {
                if (_.contains(items, object.id)) {
                    items = _.without(items, object.id);
                    itemCount--;
                }
            });

            setModel.set({
                items: items,
                itemCount: itemCount,
            });
        });
    },
});

module.exports = SetsCollection;